import * as types from './ActionTypes';
import axios from 'utils/axios';
import { API_URL } from 'configs';

const loader = label => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = 'general_error') => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType = '') => {
  const res = error?.response;
  if (res?.status === 422 && validationType) {
    dispatch({ type: validationType, validation_error: res.data.errors });
  } else {
    dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
  }
};

export const fetchJobLogs = (data = {}) => dispatch => {
  dispatch({ type: types.FETCH_ACD_JOB_LOGS });
  dispatch(loader());

  axios.get(`${API_URL}acd-reports/job-logs`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    params: data
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch({
        type: types.FETCH_ACD_JOB_LOGS_SUCCESS,
        payload: res.data,
      });
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.FETCH_ACD_JOB_LOGS_FAILURE);
    });
};

export const fetchJobLogDetails = (id, data = {}) => dispatch => {
  dispatch({ type: types.FETCH_ACD_JOB_LOG_DETAILS });
  dispatch(loader());

  axios.get(`${API_URL}acd-reports/job-logs/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    params: data
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch({
        type: types.FETCH_ACD_JOB_LOG_DETAILS_SUCCESS,
        payload: res.data,
      });
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.FETCH_ACD_JOB_LOG_DETAILS_FAILURE);
    });
};
